import {
    GETFEEDETAILSBYID_SUCCESS,
    GETFEEDETAILSBYID_FAILED,
    RESET_GETFEEDETAILSBYID,
    LOADING_GETFEEDETAILSBYID,
    NETWORK_ERROR_GETFEEDETAILSBYID,
  } from "../types/index";
  
  const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case LOADING_GETFEEDETAILSBYID:
        return {
          ...state,
          isLoading: true,
          success: false,
          failed: false,
          network: false,
          data: {},
          message: "",
          networkError: "",
        };
      case GETFEEDETAILSBYID_FAILED:
        return {
          ...state,
          isLoading: false,
          success: false,
          failed: true,
          network: false,
          data: action.payload,
          message: "",
          networkError: "",
        };
      case GETFEEDETAILSBYID_SUCCESS:
        return {
          ...state,
          isLoading: false,
          success: true,
          failed: false,
          network: false,
          data: action.payload,
          message: "",
          networkError: "",
        };
      case NETWORK_ERROR_GETFEEDETAILSBYID:
        return {
          ...state,
          isLoading: false,
          success: false,
          failed: false,
          network: true,
          data: {},
          message: "",
          networkError: "",
        };
      case RESET_GETFEEDETAILSBYID:
        return (state = initialState);
      default:
        return state;
    }
  };
  